export const theme = {
   colors: {
      teal: "hsl(180, 100%, 25%)",
      white: "hsl(0, 0%, 100%)",
      hoverTeal: "hsl(180, 100%, 40%)",
      grey: "hsl(0, 0%, 50%)",
      green: "hsl(124, 97%, 53%)",
      hoverGreen: "hsl(124, 97%, 85%)",
      red: "hsl(0, 100%, 50%)",
      hoverRed: "hsl(0, 100%, 80%)",
   },
   breakpoints: {
      mobile: 767,
   },
};